import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

const useCollections = () => {
  return useRestQuery(`${API_BASE_URL}/api/v2/collection/`);
};

export default useCollections;
